<template>
	<form
		:action="action"
		class="flex flex-col gap-12"
		novalidate
		:enctype="withFileUpload ? 'multipart/form-data' : undefined"
		@submit="(e: Event) => {
			if (honeyPotSubject) {
				return;
			}

			emit('submit', e as FormDataEvent)
		}"
	>
		<input
			v-model="honeyPotSubject"
			name="a-subject"
			class="hidden"
		>
		<input
			name="page"
			class="hidden"
			:value="route.fullPath"
		>
		<slot />
		<div class="flex flex-col">
			<div>
				<p
					v-if="isSuccess"
					class="text-green-600 text-paragraph-size-sm"
				>
					<AtomFontAwesome
						icon="fa-check"
						class="w-5 h-5 inline-block"
					/>
					Je bericht is succesvol verstuurd.
				</p>
				<p
					v-else-if="isError"
					class="text-red-600 text-paragraph-size-sm"
				>
					<LazyAtomFontAwesome
						icon="fa-triangle-exclamation"
						class="w-5 h-5 inline-block"
					/>
					Er is iets mis gegaan, probeer het later opnieuw.
				</p>
			</div>
			<div
				v-if="!hideButtons"
				class="flex flex-col sm:flex-row gap-8 justify-between w-full min-w-[50%] sm:w-auto"
			>
				<LazyAtomButton
					v-if="step && steps && step > 1"
					type="button"
					:variant="ButtonVariant.DarkBorder"
					class="w-full sm:w-auto"
					:is-disabled="isSubmitting || isSuccess || isError"
					icon-left="fa-angle-left"
					text="Vorige stap"
					@click="emit('previousStep')"
				/>
				<span
					v-else
					class="hidden sm:inline-block"
				/>
				<LazyAtomButton
					v-if="!step || !steps || step === steps"
					type="submit"
					:variant="ButtonVariant.Green"
					class="w-full sm:w-auto"
					:text="submitButtonText"
					:icon-right="submitButtonIcon"
					:is-disabled="isSubmitting || isSuccess || isError || isNextStepDisabled"
					@disabled-click="emit('nextStepDisabled')"
				/>
				<LazyAtomButton
					v-else
					type="button"
					:variant="ButtonVariant.Dark"
					class="w-full sm:w-auto"
					:is-disabled="
						isSubmitting
							|| isSuccess
							|| isError
							|| isNextStepDisabled
					"
					text="Volgende stap"
					@click="clickNextStep"
					@disabled-click="emit('nextStepDisabled')"
				/>
			</div>
		</div>
	</form>
</template>

<script setup lang="ts">
import type { FontAwesomeIconType } from '#base/app/plugins/fontawesome';
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';

const {
	action,
	isSuccess = false,
	isError = false,
	isSubmitting = false,
	step,
	steps,
	isNextStepDisabled = false,
	hideButtons = false,
	submitButtonText = 'Versturen',
	submitButtonIcon,
	withFileUpload = false,
} = defineProps<{
	action?: string;
	isSuccess?: boolean;
	isError?: boolean;
	isSubmitting?: boolean;
	step?: number;
	steps?: number;
	isNextStepDisabled?: boolean;
	hideButtons?: boolean;
	submitButtonText?: string;
	submitButtonIcon?: FontAwesomeIconType;
	withFileUpload?: boolean;
}>();

const honeyPotSubject = defineModel<string>();

const route = useRoute();

const emit = defineEmits<{
	(e: 'submit', event: FormDataEvent): void;
	(e: 'nextStepDisabled' | 'nextStep' | 'previousStep'): void;
}>();

watch(() => step, () => {
	const scrollableDialog = document?.getElementById('molecule-dialog-scrollable-container');

	if (scrollableDialog) {
		setTimeout(() => {
			scrollableDialog.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}, 100);
	}
});

const clickNextStep = () => {
	emit('nextStep');
};
</script>
